<script setup lang="ts">
import useEmblaCarousel from 'embla-carousel-vue'
import { onMounted, ref, useTemplateRef } from 'vue'
import CmsImage from '~/layers/cms/app/components/cms/CmsImage.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const OPTIONS = { dragFree: true, loop: false }
const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS)

const isUserDragging = ref(false)

const emblaBtnPrev = useTemplateRef<HTMLElement>('emblaBtnPrev')
const emblaBtnNext = useTemplateRef<HTMLElement>('emblaBtnNext')

onMounted(() => {
  if (!emblaApi.value) return

  emblaBtnNext.value?.addEventListener('click', () => {
    emblaApi.value?.scrollNext()
  })

  emblaBtnPrev.value?.addEventListener('click', () => {
    emblaApi.value?.scrollPrev()
  })

  emblaApi.value.on('pointerDown', () => {
    isUserDragging.value = true
  })

  emblaApi.value.on('pointerUp', () => {
    isUserDragging.value = false
  })
})

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Sliders/BigSlider'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <CmsCustomComponentList
      :id="component_values?.id?.value"
      v-slot="{ component_values: ComponentValues }"
      :cms-data-path="[...props.cmsDataPath, 'component_data', 'list']"
      :open-options="true"
      :component-name="nazwa_komponentu"
      class="min-w-5 min-h-5 py-10 pl-2xl flex flex-col gap-16 w-full h-auto"
    >
      <div class="flex flex-col gap-16 w-full h-auto">
        <div class="flex flex-col gap-6 w-full h-auto">
          <div class="embla w-full h-auto">
            <div
              ref="emblaRef"
              class="overflow-hidden w-full h-auto"
            >
              <div
                class="flex gap-8 select-none h-auto w-auto"
              >
                <div
                  v-for="(item, index) in ComponentValues"
                  :key="JSON.stringify(item)"
                  class="embla__slide basis-full xl:basis-auto shrink-0 h-full"
                >
                  <CmsImage
                    :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data', index, 'image']"
                    class="rounded-3xl object-cover max-h-[70svh]"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-start">
            <div class="flex flex-row ">
              <div
                ref="emblaBtnPrev"
                class="px-7.5 py-5 border border-r-0 border-Tekst rounded-l-full transition-all duration-200 group group-hover:border-Secondary cursor-pointer"
              >
                <i class="pi pi-arrow-left text-Tekst group-hover:text-Secondary text-2xl! transition-all duration-200" />
              </div>
              <div
                ref="emblaBtnNext"
                class="px-7.5 py-5 border border-l-0 border-Tekst rounded-r-full transition-all duration-200 group group-hover:border-Secondary cursor-pointer"
              >
                <i class="pi pi-arrow-right text-Tekst group-hover:text-Secondary text-2xl! transition-all duration-200" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </CmsCustomComponentList>
  </CmsCustomComponent>
</template>
